<template>
  <div>
    <v-row>
      <v-col style="max-width:420px;" cols="12" md="6">
        <v-select @input="onChange" v-model="v1"
         :items="level1" item-text="Name" item-value="Value" label />
      </v-col>
      <v-col style="max-width:400px;" cols="12" md="6">
        <v-select @input="onChange" v-if="level2 != null" v-model="v2" 
        :items="level2" item-text="Name" item-value="Value" label />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import localStorageSvc from "@/services/localStorage";
export default {
  props: ["value"],
  data() {
    return {
      v1: null,
      v2: null,
     
    };
  },

  methods: {    
    onChange() {     
      if (this.v2) {
        this.$emit("input", this.v2);
      } else {
        this.$emit("input", this.v1);
      }
    },
    setV(n){
      for (let i = 0; i < this.type.length; i++) {
        if(this.type[i].Items){
          for (let j = 0; j < this.type[i].Items.length; j++){
           if( this.type[i].Items[j].Value==n){
             this.v1 = this.type[i].Value;
             this.v2 = this.type[i].Items[j].Value
             break;
           }
         }
        } else {
          if( n == this.type[i].Value){
            this.v1 = this.type[i].Value;
            break;
          }
        }
        
      } 
    }
  },
  computed: {
    type(){
      if(localStorageSvc.getLan()=='fr'){
        return [
           {
          Name: "Detaché",
          Value: 0,
          Items: [
            {
              Name: "Detaché",
              Value: 0
            },
            {
              Name: "Duplex - Détaché",
              Value: 2
            },
            {
              Name: "Triplex - Détaché",
              Value: 8
            },
            {
              Name: "Quadruplex  - Détaché",
              Value: 13
            },
            {
              Name: "Construction modulaire  - Détaché",
              Value: 11
            }
          ]
        },
        {
          Name: "semi-détaché",
          Value: 1,
          Items: [
            {
              Name: "semi-détaché",
              Value: 1
            },
            {
              Name: "Duplex - semi-détaché",
              Value: 3
            },
            {
              Name: "Triplex - semi-détaché",
              Value: 9
            },
            {
              Name: "Quadruplex  - semi-détaché",
              Value: 14
            },
            {
              Name: "Construction modulaire  - semi-détaché",
              Value: 12
            }
          ]
        },
        {
          Name: "Maison de ville",
          Value: 4
        },
        {
          Name: "Condo / Appartement",
          Value: 5,
          Items: [
            {
              Name: "Appartement (faible hauteur)",
              Value: 5
            },
            {
              Name: "Appartement (grande hauteur)",
              Value: 6
            },
            {
              Name: "Maison empilée",
              Value: 10
            }
          ]
        },
        {
          Name: "Autre",
          Value: 7,
          Items: [
            {
              Name: "Maison mobile",
              Value: 7
            }
          ]
        }
        ]
      } else {
        return   [
        {
          Name: "Detached",
          Value: 0,
          Items: [
            {
              Name: "Detached",
              Value: 0
            },
            {
              Name: "Duplex - Detached",
              Value: 2
            },
            {
              Name: "Tri Plex - Detached",
              Value: 8
            },
            {
              Name: "Four Plex - Detached",
              Value: 13
            },
            {
              Name: "Modular Home - Detached",
              Value: 11
            }
          ]
        },
        {
          Name: "Semi-Detached",
          Value: 1,
          Items: [
            {
              Name: "Semi-Detached",
              Value: 1
            },
            {
              Name: "Duplex - Semi-Detached",
              Value: 3
            },
            {
              Name: "Tri Plex - Semi-Detached",
              Value: 9
            },
            {
              Name: "Four Plex - Semi-Detached",
              Value: 14
            },
            {
              Name: "Modular Home - Semi-Detached",
              Value: 12
            }
          ]
        },
        {
          Name: "Row Housing",
          Value: 4
        },
        {
          Name: "Condo / Apartment",
          Value: 5,
          Items: [
            {
              Name: "Apartment Low Rise",
              Value: 5
            },
            {
              Name: "Apartment High Rise",
              Value: 6
            },
            {
              Name: "Stacked",
              Value: 10
            }
          ]
        },
        {
          Name: "Other",
          Value: 7,
          Items: [
            {
              Name: "Mobile",
              Value: 7
            }
          ]
        }
      ];
      }
    },
    level1() {
      let rv = [];
      for (let i = 0; i < this.type.length; i++) rv.push(this.type[i]);
      return rv;
    },
    level2() {
      let rv = null;
      for (let i = 0; i < this.type.length; i++) {
        if (this.type[i].Value == this.v1) {
          if (this.type[i].Items) {
            rv = [];
            for (let j = 0; j < this.type[i].Items.length; j++) rv.push(this.type[i].Items[j]);
          } else {
            rv = null;
          }
        }
      }
      return rv;
    }
  },
  watch: {
    value(n) {       
      this.setV(n); 
    }
  }
};
</script>

